import { Stack } from '@mui/material';
import { useFlightsFilters } from 'legacyfrontend/contexts/FlightsFiltersContext';

export const ToggleSwitch = ({
  isActive,
  onChange,
  label,
  icon: Icon,
  disabled = false,
  background,
}) => {
  const { isLoading } = useFlightsFilters();

  const getBackgroundColor = () => {
    if (isLoading || disabled) return '#E5E7EB';
    return !isActive ? '#ccc' : background;
  };

  return (
    <Stack direction='row' justifyContent='space-between' width='100%'>
      <div className='flex items-center gap-2'>
        {Icon && <Icon className='w-5 h-5' sx={{ color: isLoading ? '#9CA3AF' : background }} />}
        {label && (
          <span className={`font-medium ${isLoading ? 'text-gray-400' : 'text-gray-700'}`}>
            {label}
          </span>
        )}
      </div>
      <button
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 ${
          isLoading || disabled ? 'cursor-not-allowed opacity-60' : ''
        }`}
        disabled={isLoading || disabled}
        onClick={onChange}
        style={{ backgroundColor: getBackgroundColor() }}
      >
        <span className='sr-only'>
          Toggle
          {label}
        </span>
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition duration-300 ${
            !isActive ? 'translate-x-1' : 'translate-x-6'
          }`}
        />
      </button>
    </Stack>
  );
};
